import { ApiResult } from '../models/ApiResult';
import { DeviceType } from '../models/DeviceType/DeviceType.model';
import { apiClient } from './ApiService';

type CreateDeviceTypeData = {
  name: string;
  category: string;
  manufacturer?: string | null;
  description?: string;
  model_name?: string;
  model_number?: string;
  image?: File | null;
  hardware_id?: string;
};

type UpdateDeviceTypeData = Partial<CreateDeviceTypeData>;

type DeviceTypeOption = {
  value: string;
  label: string;
};

const getDeviceTypes = async (): Promise<ApiResult<DeviceType[]>> => {
  const response = await apiClient.get<{ status: number; message: string; data: DeviceType[] }>(
    '/drone_commander/device-types/'
  );
  return { success: true, data: response.data };
};

const createDeviceType = async (data: CreateDeviceTypeData): Promise<ApiResult<DeviceType>> => {
  const response = await apiClient.post<DeviceType>('/drone_commander/device-types/', data);
  return { success: true, data: response };
};

const updateDeviceType = async (id: string, data: UpdateDeviceTypeData): Promise<ApiResult<DeviceType>> => {
  const response = await apiClient.patch<DeviceType>(`/drone_commander/device-types/${id}/`, data);
  return { success: true, data: response };
};

const deleteDeviceType = async (id: string): Promise<ApiResult<null>> => {
  await apiClient.delete(`/drone_commander/device-types/${id}/`, {});
  return { success: true, data: null };
};

const getDeviceTypeOptions = async (): Promise<ApiResult<DeviceTypeOption[]>> => {
  const data = await apiClient.get<DeviceType[]>('/drone_commander/device-types/');
  const options = data.map((dt: DeviceType) => ({ value: dt.id, label: dt.name }));
  return { success: true, data: options };
};

export const DeviceTypeService = {
  getDeviceTypes,
  createDeviceType,
  updateDeviceType,
  deleteDeviceType,
  getDeviceTypeOptions
};
